
import contactus from './contact-us'
import news from './news'
import enterprise from './enterprise'
import securityService from './securityService'
import securityTrain from './securityTrain'
import knowledge from './knowledge'
import cloudMarket from './cloudMarket'
import enterpriseManagement from './enterpriseManagement'
import openPlatform from './openPlatform'
const modules = {
  path: '/',
  component: resolve => require(['../../../pages/modules'], resolve),
  redirect: '/home',
  children: [
    contactus,
    news,
    enterprise,
    securityService,
    securityTrain,
    knowledge,
    enterpriseManagement,
    cloudMarket,
    openPlatform
  ]
}

export default modules
